import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { pathname } from '../../../../utils';
import { useHistory } from 'react-router';
import { faqUrl } from '../../../../utils';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import LoadingButton from '../../../lowLevel/LoadingButton';
import UrlLink from '@material-ui/core/Link';

const useStyles = makeStyles((theme: any) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  dialogAction: { alignSelf: 'center' },
  button: {
    marginTop: theme.spacing(2),
    minWidth: 175,
  },
}));

export default function IncompleteData({ loading, closeDialog, storeName }) {
  const classes = useStyles();
  const history = useHistory();

  const content = (
    <>
      <Typography gutterBottom>
        Our team has decided not to offer {storeName} a Growth Plan at this
        time, since we do not have sufficient data to thoroughly assess this
        application.
      </Typography>
      <Typography>
        <b>What happens next?</b>
      </Typography>
      <Typography>
        We encourage you to verify that your store and bank account are
        correctly connected, before attempting to resubmit your Lines.
      </Typography>
      <Typography>
        If you believe we made a mistake, please resubmit your Lines, and
        include any supporting information that can help our team make a
        decision.
      </Typography>
      <Typography>
        To read more about the data we collect and how we make decisions, please
        see our{' '}
        <UrlLink href={faqUrl} target="_blank">
          FAQs
        </UrlLink>
        .
      </Typography>
    </>
  );

  const actions = (
    <LoadingButton
      className={classes.button}
      loading={loading}
      onClick={() => history.push(pathname.account.main.url)}
    >
      <b>Go to Account</b>
    </LoadingButton>
  );

  return (
    <>
      <DialogContent className={classes.root}>{content}</DialogContent>
      <DialogActions className={classes.dialogAction}>{actions}</DialogActions>
    </>
  );
}
